// extracted by mini-css-extract-plugin
export default {"companyContainer":"PO-z","companyImage":"QO-z","container":"RO-z","heading":"SO-z","darkText":"TO-z","smallHeading":"UO-z","darkBackground":"VO-z","whiteBackground":"WO-z"};